import * as React from 'react';
import * as _ from 'lodash';
import Dropzone from 'react-dropzone';
import { ColorPicker } from './../../PageLayout/ColorPicker';
export default function () {
    function onBlur1(AR, e) {
        this.setState({ name: e.target.value });
    }
    function mergeProps(inline, external) {
        var res = _.assign({}, inline, external);
        if (inline.hasOwnProperty('style')) {
            res.style = _.defaults(res.style, inline.style);
        }
        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
            res.className = external.className + ' ' + inline.className;
        }
        return res;
    }
    function onBlur3(AR, e) {
        this.setState({ description: e.target.value });
    }
    function onClick4(AR) {
        if (!this.state.newMaterialFilterVisible)
            this.setState({
                newMaterialFilterVisible: true,
                newMaterialFilterValue: '',
                newMaterialFilterQuartz: false
            });
    }
    function onClick5(AR, item, itemIndex) {
        this.handleItemClick(item);
    }
    function onClick6(AR, item, itemIndex, sub, subIndex) {
        this.handleItemClick(sub);
    }
    function repeatSub7(AR, item, itemIndex, sub, subIndex) {
        return [React.createElement('div', {
                'className': 'add-stone-lir',
                'onClick': onClick6.bind(this, AR, item, itemIndex, sub, subIndex),
                'key': '40561'
            }, React.createElement('div', { 'className': 'radio-ring' }, React.createElement('div', { 'className': this.isChecked(sub) ? 'radio-check' : '' })), React.createElement('span', { 'className': 'add-stone-lir-text' }, sub.value))];
    }
    function repeatItem8(AR, item, itemIndex) {
        return [React.createElement('div', {
                'className': 'add-stone-lir-wrapper',
                'style': { height: 'auto' },
                'key': '28961'
            }, React.createElement('div', {
                'className': 'add-stone-lir',
                'onClick': onClick5.bind(this, AR, item, itemIndex)
            }, React.createElement('div', { 'className': 'radio-ring' }, item.items && item.items.length > 0 ? [React.createElement('div', {
                    'className': this.isChecked(item) ? 'radio-arrow-open' : 'radio-arrow-closed',
                    'key': '32701'
                })] : null, !item.items || item.items.length == 0 ? [React.createElement('div', {
                    'className': this.isChecked(item) ? 'radio-check' : '',
                    'key': '35311'
                })] : null), React.createElement('span', { 'className': 'add-stone-lir-text' }, item.value)), this.isChecked(item) && item.items && item.items.length > 0 ? React.createElement.apply(this, [
                'div',
                {
                    'className': 'add-stone-sub-lir',
                    'key': '3923'
                },
                _.map(item.items, repeatSub7.bind(this, AR, item, itemIndex))
            ]) : null)];
    }
    function onChange9(AR, e) {
        this.setState({ newMaterialFilterValue: e.target.value });
    }
    function onClick10(AR) {
        this.setState({ newMaterialFilterQuartz: !this.state.newMaterialFilterQuartz });
    }
    function onClick11(AR) {
        this.setState({ newMaterialFilterVisible: false });
    }
    function onClick12(AR) {
        if (!this.state.newColorFilterVisible)
            this.setState({
                newColorFilterVisible: true,
                newColorFilterValue: '',
                newColorFilterName: ''
            });
    }
    function onClick13(AR, color, colorIndex) {
        this.handleItemClick(color, 'colors');
    }
    function repeatColor14(AR, color, colorIndex) {
        return [React.createElement('div', {
                'className': 'add-stone-lir-wrapper',
                'onClick': onClick13.bind(this, AR, color, colorIndex),
                'key': '68231'
            }, React.createElement('div', { 'className': 'add-stone-lir' }, React.createElement('div', { 'className': 'radio-ring' }, React.createElement('div', { 'className': this.isChecked(color, 'colors') ? 'radio-check' : '' })), React.createElement('span', { 'className': 'add-stone-lir-text' }, color.displayText)))];
    }
    function onItemClick15(AR, color) {
        this.setState({ newColorFilterValue: color });
    }
    function onChange16(AR, e) {
        this.setState({ newColorFilterName: e.target.value });
    }
    function onClick17(AR) {
        this.setState({ newColorFilterVisible: false });
    }
    function scopeAR18() {
        var AR = this.props.AR;
        return React.createElement('div', { 'className': 'ui-popup ui-popup--large' }, React.createElement('div', { 'className': 'ui-popup-header' }, React.createElement('span', { 'className': 'ui-popup-header__text' }, this.props.stone ? 'Edit' : 'Add New', ' Stone'), React.createElement('button', {
            'className': 'ui-popup-header__close',
            'onClick': this.props.close
        })), React.createElement('div', { 'className': 'ui-popup-body ui-popup-body--small' }, React.createElement('div', { 'className': 'add-stone-container' }, React.createElement('div', { 'className': 'add-stone-col-1' }, React.createElement('div', { 'className': 'add-stone-image-upload' }, React.createElement('div', { 'style': this.imageUploadStyles() }, this.state.warnings && this.state.warnings.length > 0 ? React.createElement('span', {
            'className': 'icon-warning',
            'onClick': this.showWarning,
            'key': '708'
        }, '!') : null, React.createElement(Dropzone, {
            'accept': 'image/jpeg, image/png',
            'onDrop': this.onDrop,
            'style': this.imageUploadDropzoneStyles(),
            'acceptStyle': {
                'boxShadow': '0 0 1em green inset',
                'backgroundColor': 'rgba(0,192,0,0.3)'
            },
            'rejectStyle': {
                'boxShadow': '0 0 1em red inset',
                'backgroundColor': 'rgba(192,0,0,0.3)'
            }
        }, React.createElement('div', { 'className': 'add-stone-image-upload-icon ' + (this.props.stone ? 'add-stone-image-upload-icon-edit' : '') })))), React.createElement('input', mergeProps({
            'className': 'generic-popup-textbox bold',
            'placeholder': 'Enter Stone Name',
            'defaultValue': this.state.name,
            'onBlur': onBlur1.bind(this, AR),
            'maxLength': '45'
        }, { disabled: this.props.stone && !(AR.isSiteAdmin() || this.props.stone && AR.isMe(this.props.stone.createdById)) })), React.createElement('textarea', mergeProps({
            'className': 'generic-popup-textarea-small fixed',
            'placeholder': 'Enter Stone Description',
            'defaultValue': this.state.description,
            'onBlur': onBlur3.bind(this, AR),
            'maxLength': '2048'
        }, { disabled: this.props.stone && !(AR.isSiteAdmin() || this.props.stone && AR.isMe(this.props.stone.createdById)) }))), React.createElement('div', { 'className': 'wrapper' }, React.createElement('h2', {}, 'Assign Material Filter'), React.createElement('div', {
            'className': 'add-stone-new-filter ' + (this.state.newMaterialFilterVisible ? 'disabled' : ''),
            'onClick': onClick4.bind(this, AR)
        }, 'New Material Filter'), React.createElement.apply(this, [
            'div',
            { 'className': 'add-stone-col-2' },
            !this.state.newMaterialFilterVisible ? _.map(this.props.materialFilters, repeatItem8.bind(this, AR)) : null,
            this.state.newMaterialFilterVisible ? React.createElement('div', {
                'className': 'add-stone-new-filter-container',
                'key': '4736'
            }, React.createElement('div', { 'className': 'add-stone-new-filter-text' }, '\r\n                            Name your new stone filter. Select Quartz if you wish to add it to the Quartz Main Menu.\r\n                        '), React.createElement('input', {
                'type': 'text',
                'placeholder': 'Enter Filter Name',
                'className': 'generic-popup-textbox',
                'value': this.state.newMaterialFilterValue,
                'onChange': onChange9.bind(this, AR),
                'maxLength': '50'
            }), React.createElement('div', { 'className': 'add-stone-radio-container' }, React.createElement('div', {
                'className': 'radio-ring',
                'onClick': onClick10.bind(this, AR)
            }, React.createElement('div', { 'className': this.state.newMaterialFilterQuartz ? 'radio-check' : '' })), React.createElement('h1', {}, 'Quartz')), React.createElement('div', { 'className': 'app-content-footer__buttons' }, React.createElement('button', {
                'className': 'ui-button4 ui-button4--blue',
                'onClick': onClick11.bind(this, AR)
            }, 'Cancel'), React.createElement('button', {
                'className': 'ui-button4 ui-button4--green',
                'onClick': this.saveNewMaterialFilter
            }, 'Create'))) : null
        ])), React.createElement('div', { 'className': 'wrapper' }, React.createElement('h2', {}, 'Assign Color Filter'), React.createElement('div', {
            'className': 'add-stone-new-filter ' + (this.state.newColorFilterVisible ? 'disabled' : ''),
            'onClick': onClick12.bind(this, AR)
        }, 'New Color Filter'), React.createElement.apply(this, [
            'div',
            { 'className': 'add-stone-col-3' },
            !this.state.newColorFilterVisible ? _.map(this.props.colorFilters, repeatColor14.bind(this, AR)) : null,
            this.state.newColorFilterVisible ? React.createElement('div', {
                'className': 'add-stone-new-filter-container',
                'key': '7524'
            }, React.createElement(ColorPicker, {
                'backgroundComponentCSS': 'color-picker-hex-bg',
                'color': this.state.newColorFilterValue,
                'onItemClick': onItemClick15.bind(this, AR)
            }), React.createElement('input', {
                'type': 'text',
                'placeholder': 'Enter Color Name',
                'className': 'generic-popup-textbox',
                'value': this.state.newColorFilterName,
                'onChange': onChange16.bind(this, AR),
                'maxLength': '50'
            }), React.createElement('div', { 'className': 'app-content-footer__buttons' }, React.createElement('button', {
                'className': 'ui-button4 ui-button4--blue',
                'onClick': onClick17.bind(this, AR)
            }, 'Cancel'), React.createElement('button', {
                'className': 'ui-button4 ui-button4--green',
                'onClick': this.saveNewColorFilter
            }, 'Create'))) : null
        ])))), React.createElement('div', { 'className': 'ui-popup-footer' }, React.createElement('button', {
            'className': 'ui-button ui-button--blue',
            'onClick': this.props.close
        }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Cancel')), React.createElement('button', {
            'className': 'ui-button ui-button--green',
            'onClick': this.handleSave
        }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Save'))));
    }
    return scopeAR18.apply(this, []);
}